import axios from "axios";

const errorCodesBaseUrl = process.env.REACT_APP_GITO_API_URL + "/manufacturer/ErrorCode";
const manufacturerBaseUrl = process.env.REACT_APP_GITO_API_URL + "/manufacturer/Manufacturer";
//const manufacturerBaseUrl = "https://localhost:7241/Manufacturer";
//const errorCodesBaseUrl = "https://localhost:7241/ErrorCode";


export async function getManufacturerErrorCodes(manufacturerPublicId, apiAccessToken) {
    try {
        const response = await axios.get(
            `${errorCodesBaseUrl}/get-manufacturer-error-codes/${manufacturerPublicId}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to fetch manufactuer error codes"
        );
    }
}

export async function updateErrorCode(errorCodesData, apiAccessToken) {
    try {
        console.log("Charging point data being sent to API:", errorCodesData);

        const response = await axios.put(
            `${errorCodesBaseUrl}/update-error-code`,
            errorCodesData,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to update charging point"
        );
    }
}

export async function deleteManufacturerErrorCode(
    errorCodePublicId,
    apiAccessToken
) {
    try {
        const response = await axios.delete(
            `${errorCodesBaseUrl}/delete-error-code/${errorCodePublicId}`,
            {
                headers: {
                    Authorization: `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to delete error code"
        );
    }
}

export async function createErrorCode(errorCodesData, apiAccessToken) {
    try {
        console.log("Charging point data being sent to API:", errorCodesData);

        const response = await axios.post(
            `${errorCodesBaseUrl}/create-error-code`,
            errorCodesData,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to update charging point"
        );
    }
}
// MANUFACTURER
export async function getManufacturers(apiAccessToken) {
    try {
        const response = await axios.get(`${manufacturerBaseUrl}/get-manufacturers`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to fetch manufacturers"
        );
    }
}

export async function getManufacturerByPublicId(apiAccessToken, manufacturerPublicId) {
    try {
        const response = await axios.get(`${manufacturerBaseUrl}/get-manufacturer/${manufacturerPublicId}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to fetch manufacturer"
        );
    }
}

// Function to create a new manufacturer
export async function createManufacturer(manufacturerData, apiAccessToken) {
    try {
        const response = await axios.post(
            `${manufacturerBaseUrl}/create-manufacturer`,
            manufacturerData,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to create charging point"
        );
    }
}

// Function to delete a manufacturer by manufacturerPublicId
export async function deleteManufacturer(manufacturerPublicId, apiAccessToken) {
    try {
        const response = await axios.delete(
            `${manufacturerBaseUrl}/delete-manufacturer/${manufacturerPublicId}`,
            {
                headers: {
                    Authorization: `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to delete manufacturer"
        );
    }
}
